
import { Vue, Component } from 'vue-property-decorator'
import { lists } from '../utils/faqs'

@Component
export default class FAQSection extends Vue {
    faqLists = lists
}
